import React from "react";
//import { Modal, Button } from 'react-bootstrap';

const PopupDelete = ({ message, title, modalstatus, btnClickDelete, btnClickClose }) =>{

    return(
    <>
    <div className={modalstatus ? 'modal fade show' : 'modal fade' } id="exampleModalScrollable2" tabindex="-1" aria-labelledby="exampleModalScrollable2" data-bs-keyboard="false" aria-hidden="true">
        <div class="modal-dialog modal-dialog-centered">
            <div class="modal-content">
                <div class="modal-header">
                    <h4 class="modal-title" id="staticBackdropLabel2">{title}</h4>
                    <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close" onClick={btnClickClose}></button>
                </div>
                <div class="modal-body">
                    <p>{message}</p>
                </div>
                <div class="modal-footer">
                    <button type="button" class="btn btn-cancel" data-bs-dismiss="modal" onClick={btnClickClose}>Close</button>
                    <button type="button" class="btn btn-primary" onClick={btnClickDelete}>Delete</button>
                </div>
            </div>
        </div>
    </div>
    
    {/*<Modal show={modalstatus} onHide={btnClickClose} centered>
        <Modal.Header closeButton>
            <Modal.Title id="contained-modal-title-vcenter">{title}</Modal.Title>
        </Modal.Header>
        <Modal.Body>{message}</Modal.Body>
        <Modal.Footer>
            <Button variant="cancel" onClick={btnClickClose} > Close </Button>
            <Button variant="primary" onClick={btnClickDelete}> Delete </Button>
        </Modal.Footer>
    </Modal>*/}
    </>
    )
}

export default PopupDelete;